import { useFlag } from "@openfeature/react-sdk";
import { OptionSeparatorModel } from "metx-core/src/overlay/components/LayerStackWindow/PlotSerieOptions";
import {
  stationModels_TEMPORAL,
  useWeatherParamModels,
  winterdienstStationModels_TEMPORAL,
} from "metx-core/src/weather-parameters";

export function getAvailableWeatherModels(availableModels?: string[], hasStationModels?: boolean) {
  const weatherModels = useWeatherParamModels();
  const { value: winterdienstStationsEnabled } = useFlag("winterdienst-stations", false);

  if (weatherModels) {
    return [
      ...weatherModels.filter((model) => availableModels?.includes(model.identifier)),
      ...(hasStationModels
        ? [
            OptionSeparatorModel,
            ...stationModels_TEMPORAL,
            ...(winterdienstStationsEnabled ? winterdienstStationModels_TEMPORAL : []),
          ]
        : []),
    ];
  }

  return [];
}
